const {Component} = require("react");
const PropTypes = require("prop-types");
const Link = require("app/components/mixins/Link");
const Trans = require('app/components/trans/Trans')

class Item extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string.isRequired,
			guid: PropTypes.any.isRequired,
			url: PropTypes.string,
			count: PropTypes.number,
			active: PropTypes.bool,
			onActivate: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			count: 0,
			url: "#",
			active: false
		};
	}

	constructor(props) {
		super(props);
		this.state = {
			count: props.count,
			active: props.active
		};
	}

	componentWillReceiveProps(nextProps) {
		let state = {};

		if ((typeof nextProps.count === "number") && (this.state.count !== nextProps.count)) {
			state.count = nextProps.count;
		}

		if ((typeof  nextProps.active === "boolean") && (this.state.active !== nextProps.active)) {
			state.active = nextProps.active;
		}

		if (Object.keys(state).length > 0) {
			this.setState(state);
		}
	}

	get className() {
		let classList = [];

		if (this.state.active) {
			classList.push("active");
		}

		if (this.state.count === 0) {
			classList.push("empty");
		}

		return classList.join(" ");
	}

	_onActivate = () => {
		if (typeof this.props.onActivate === "function") {
			this.props.onActivate(this.props.guid);
		}
	};

	render() {
		return (
			<Link href={this.props.url} className={this.className} onClick={this._onActivate}>
				<span className="title">{this.props.title}</span>
				<span className="counter">{this.state.count}</span>
			</Link>
		);
	}

}

class Filter extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string,
			items: PropTypes.array
		};
	}

	static get defaultProps() {
		return {
			title: translate("Undergrupper"),
			items: []
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			activeItem: null,
			items: props.items
		};
	}

	get className() {
		let classList = ["category-filter"];

		if (this.state.activeItem) {
			classList.push("has-selection");
		}

		if (this.state.items.length === 0) {
			classList.push("hidden");
		}

		return classList.join(" ");
	}

	onActivate(guid) {
		this.setState({activeItem: guid});
	}

	_onReset = (e) => {
		e.preventDefault();
		this.onActivate(null);
	};

	renderItems() {
		return this.state.items.map(item => {
			let active = this.state.activeItem === item.guid;

			return (
				<Item key={item.guid} active={active} onActivate={this.onActivate.bind(this)} {...item} />
			);
		});
	}

	renderReset() {
		if (this.state.activeItem) {
			return (
				<Link href="#" className="reset" onClick={this._onReset}><Trans>Nulstil</Trans></Link>
			);
		}
	}

	render() {
		return (
			<div className={this.className}>
				<div className="header">
					<div className="title">{this.props.title}</div>
					{this.renderReset()}
				</div>
				<div className="items">{this.renderItems()}</div>
			</div>
		);
	}

}

module.exports = Filter;
